export default class ExportPdfTimeCommand {
    constructor(
        public hubName: string,
        public feedType: string,  // place, event
        public downloadType: string, // all, editor's choice, selected
        public startTime: Date,
        public endTime: Date,
        public version: string,   // online, print
        public category: string,  // place category
        public itemExportCount: number
    ) {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/export.pdf.time.command.ts